import React from 'react';
import { Box } from '@material-ui/core';

const Pagination = ({ theme, maxVisiblePages = 5, illustrative = false, ...props }) => {
  const primaryColor = theme?.palette?.primary?.main || '#e0e0e0';
  const pagesToShow = Math.min(parseInt(maxVisiblePages, 10) || 5, 10);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" gap={0.5} {...props}>
      {/* Prev Arrow */}
      <Box width={32} height={32} display="flex" alignItems="center" justifyContent="center" borderRadius={4} bgcolor="#f5f5f5">
        <Box width={8} height={8} bgcolor="#bdbdbd" style={{ clipPath: 'polygon(100% 0, 0 50%, 100% 100%)' }} />
      </Box>

      {/* Pages */}
      {Array.from({ length: pagesToShow }).map((_, i) => (
        <Box
        // eslint-disable-next-line react/no-array-index-key
          key={`page-${i}`}
          width={32}
          height={32}
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor={i === 0 ? `${primaryColor}15` : 'transparent'}
          borderRadius={4}
          border={i === 0 ? 'none' : '1px solid transparent'}
        >
          {illustrative ? i + 1 : (
            <Box width={8} height={8} borderRadius="50%" bgcolor={i === 0 ? primaryColor : '#e0e0e0'} />
          )}
        </Box>
      ))}

      {/* Ellipsis - show only if there are many pages */}
      {pagesToShow >= 5 && (
        <Box width={32} height={32} display="flex" alignItems="center" justifyContent="center">
          <Box width={16} height={4} display="flex" justifyContent="space-between">
            <Box width={3} height={3} borderRadius="50%" bgcolor="#bdbdbd" />
            <Box width={3} height={3} borderRadius="50%" bgcolor="#bdbdbd" />
            <Box width={3} height={3} borderRadius="50%" bgcolor="#bdbdbd" />
          </Box>
        </Box>
      )}

      {/* Next Arrow */}
      <Box width={32} height={32} display="flex" alignItems="center" justifyContent="center" borderRadius={4} bgcolor="#f5f5f5">
        <Box width={8} height={8} bgcolor="#bdbdbd" style={{ clipPath: 'polygon(0 0, 100% 50%, 0 100%)' }} />
      </Box>
    </Box>
  );
};

export default Pagination;
